import styled from "styled-components";
import { BodyDefault } from "../../typography/styled";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 10px 20px;
  gap: 30px;
  box-sizing: border-box;
  width: 390px;
  /* height: 350px; */
  left: 540px;
  top: 305px;
  background: ${({theme}) => theme.palette[10]};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`

export const IconBackground = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 10px;
  width: 100px;
  height: 100px;
  background: linear-gradient(180deg, #FFEBEA 0%, #FFF8F8 100%);
  border-radius: 60px;
  margin-bottom: 14px;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`
export const BodyModal = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  padding:0px 10px;
`
export const GreyText = styled(BodyDefault)`
  color:${({theme}) => theme.palette[800]};
  margin:8px 0px 20px;
  text-align: center;
`

export const Icon = styled.img`
  &:hover{
    cursor: pointer;
  }
`

export const InstanceWrapper = styled.div`
  background-color: ${({theme}) =>  theme.palette[200]};
  display:flex;
  padding: 5px 8px;
  border-radius: 4px;
  margin:3px;
  align-items: center;
`

export const Title = styled(BodyDefault)`
  color:${({theme}) => theme.isDark ? theme.palette[800] : theme.palette[900]};
  /* white-space: nowrap; */
  word-break: break-all;
  max-width: 340px;
`

export const StyledIconColored = styled.img`
  margin-right:9px;
  width: 20px;
  height: 20px;
`
